import maxinePic from "@/public/images/artists/maxine.png";
import { Artist } from "@/types/types";

export const maxine = {
  id: "256",
  name: "Maxine",
  image: maxinePic,
  description: `Maxine's voice is warm at the center but always airy around the edges. She can hit with bright, focused power, but her sound still feels soft and breathable.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmaxine-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "Airy", "Pop", "Ethereal", "Falsetto", "Indie"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Very high",
      },
      specific: {
        low: 56,
        high: 74,
      },
      sweetSpot: 65,
    },
  },
} as const satisfies Artist;
